<template>
    <div class="troubleshooting-section">
        <button
            class="troubleshooting-toggle"
            type="button"
            @click="expanded = !expanded"
        >
            <span>{{ title }}</span>
            <i :class="expanded ? 'mi-chevron-up' : 'mi-chevron-down'" />
        </button>

        <div
            v-if="expanded"
            class="troubleshooting-content"
        >
            <p class="troubleshooting-intro">
                {{ intro }}
            </p>

            <div
                v-if="steps.length"
                class="troubleshooting-steps"
            >
                <ul>
                    <li
                        v-for="(step, index) in steps"
                        :key="index"
                    >
                        {{ step }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

defineProps<{
    title: string
    intro: string
    steps: string[]
}>()

const expanded = ref(false)
</script>

<style lang="sass" scoped>
.troubleshooting-section
    @apply mt-4

.troubleshooting-toggle
    display: flex
    align-items: center
    gap: 8px
    width: 100%
    @apply py-1 px-2
    background: var(--tl-color-surface-secondary, #f5f5f5)
    border: 1px solid var(--tl-color-border, #e0e0e0)
    border-radius: 8px
    cursor: pointer
    font-weight: 600
    color: var(--tl-color-text-primary, #333)
    text-align: left
    transition: background-color 0.2s ease

    &:hover
        background: var(--tl-color-surface-hover, #ebebeb)

    i
        font-size: 12px
        transition: transform 0.2s ease

.troubleshooting-content
    @apply p-3
    @apply mt-1
    background: var(--tl-color-surface-secondary, #fafafa)
    border-radius: 8px
    font-size: 14px
    line-height: 1.6

.troubleshooting-intro
    @apply mb-4
    color: var(--tl-color-text-secondary, #666)

.troubleshooting-steps
    @apply my-4

    ul
        margin: 0
        padding-left: 24px
        list-style-type: disc

        li
            margin-bottom: 8px
            color: var(--tl-color-text-secondary, #666)

            &:last-child
                margin-bottom: 0
</style>
